import React, { Component } from 'react';
import {Link} from 'react-router-dom';
import styles from './index.css';
import YouTube from 'react-youtube';
import FontAwesome from 'react-fontawesome';

export default class Login extends Component {
    state={
        visible:false
    };

    render() {
        return (
            <div>
                <div className={styles.youtubeContainer}>
                    <YouTube className={styles.video}
                             videoId="T8hxgjIOcZ0"
                             opts={
                                 {
                                     playerVars: {
                                         autoplay: 1,
                                         loop: 0,
                                         rel: 0,
                                         modestbranding: 1,
                                         showinfo: 0,
                                         controls: 0,
                                         start: 4
                                     }
                                 }
                             }
                             onReady={(e)=>{e.target.mute();this.setState({video:e.target})}}
                    />
                </div>
                <div className={styles.hoverWindow}>
                    <form noValidate>
                        <div><h2>Login</h2></div>
                        <div>
                            <div>
                                <span>Enter your Email:</span>
                                <span className={styles.inputContainer}>
                                    <input name="email" type="email" placeholder="Enter your account email please" />
                                </span>
                            </div>
                        </div>
                        <div >
                            <div>
                                <span>Enter your Password:</span>
                                <span className={styles.inputContainer}>
                                    <input name="password" type={this.state.visible ? "text" : "password"} placeholder="Enter your account password"  />
                                    {this.state.visible ?
                                        <FontAwesome name='far fa-eye' className={styles.eyeIcon} onClick={()=>{this.setState({visible:!this.state.visible})}}/>
                                        :
                                        <FontAwesome name='far fa-eye-slash' className={styles.eyeIcon} onClick={()=>{this.setState({visible:!this.state.visible})}}/>
                                    }
                                </span>
                            </div>
                        </div>
                        <div className={styles.submit}>
                            <div>
                                <span>
                                    <Link to="/repassword">Forgot your password?</Link></span>
                                <span >Don’t have an account?
                                    <Link to="/signup"> Please Register</Link>
                                </span>
                            </div>
                            <Link to="/" className={styles.menuButton}>Login</Link>
                        </div>
                    </form>
                </div>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/shared/containers/Login/index.js